import { BufferingOverlay, CastStatusOverlay, ErrorMessageOverlay, PlaybackToggleOverlay, PlayerUtils, SubtitleOverlay, UIContainer } from 'bitmovin-player-ui';
import { createCTABar } from './components/nativemobile/ctabar';
import { createControlBar } from './components/nativemobile/controlbar';
import { createTopBar } from './components/nativemobile/topbar';
import { createMiddleButtons } from './components/nativemobile/buttons';
import { createTitleBar } from './components/nativemobile/titlebar';
const defaultData = {
    defaultActionRequired: true
};
export function sendCustomMessage(message, data) {
    try {
        return data === undefined
            ? JSON.parse(window.bitmovin.customMessageHandler.sendSynchronous(message))
            : JSON.parse(window.bitmovin.customMessageHandler.sendSynchronous(message, JSON.stringify(data)));
    }
    catch {
        return defaultData;
    }
}
export function nativeMobileUIContainer(player) {
    const middleButtons = createMiddleButtons(player);
    const ctaBar = createCTABar(player);
    const topBar = createTopBar(player);
    const controlBar = createControlBar(player);
    const errorMessageOverlay = new ErrorMessageOverlay();
    return new UIContainer({
        components: [
            new SubtitleOverlay(),
            new BufferingOverlay(),
            new PlaybackToggleOverlay(),
            new CastStatusOverlay(),
            middleButtons,
            controlBar,
            ctaBar,
            topBar,
            createTitleBar(),
            errorMessageOverlay
        ],
        cssClasses: ['npo-player', 'native-mobile'],
        hidePlayerStateExceptions: [PlayerUtils.PlayerState.Paused, PlayerUtils.PlayerState.Finished]
    });
}
